import { CollectionType, PluralAttribute } from './PluralAttribute';
export class CollectionAttribute extends PluralAttribute {
    /**
     * @inheritDoc
     */
    get collectionType() {
        return CollectionType.COLLECTION;
    }
    /**
     * @param name - the name of the attribute
     * @param typeConstructor - The collection constructor of the attribute
     * @param elementType - The element type of the collection
     */
    constructor(name, typeConstructor, elementType) {
        super(name, typeConstructor, elementType);
        super(name, typeConstructor, elementType);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sbGVjdGlvbkF0dHJpYnV0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkNvbGxlY3Rpb25BdHRyaWJ1dGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxlQUFlLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUlwRSxNQUFNLE9BQWdCLG1CQUEwQixTQUFRLGVBQXFCO0lBQzNFOztPQUVHO0lBQ0gsSUFBSSxjQUFjO1FBQ2hCLE9BQU8sY0FBYyxDQUFDLFVBQVUsQ0FBQztJQUNuQyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNILFlBQXNCLElBQVksRUFBRSxlQUF5QixFQUFFLFdBQW9CO1FBQ2pGLEtBQUssQ0FBQyxJQUFJLEVBQUUsZUFBZSxFQUFFLFdBQVcsQ0FBQyxDQUFDO1FBQzFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsZUFBZSxFQUFFLFdBQVcsQ0FBQyxDQUFDO0lBQzVDLENBQUM7Q0FDRiJ9